export const REQUEST_PASSWORD_RESET_PENDING = 'REQUEST_PASSWORD_RESET_PENDING'
export const REQUEST_PASSWORD_RESET_SUCCESSFUL =
  'REQUEST_PASSWORD_RESET_SUCCESSFUL'
export const REQUEST_PASSWORD_RESET_ERROR = 'REQUEST_PASSWORD_RESET_ERROR'
